module.exports = __webpack_public_path__ + "static/media/adventureIcon.9d24bf52.png";